import React from "react";
import { Button } from "@ann/web-components";
import { 
  TextInputContainer, 
  TextArea,
  ButtonsRow, 
  LeftButtonContainer, 
  RightButtonContainer 
} from "./TextInput.styled";

const TextInput = ({ value, onChange, placeholder = "Type your instructions here..." }) => {
  return (
    <TextInputContainer>
      <TextArea
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
      />
      <ButtonsRow>
        <LeftButtonContainer>
          <Button
            icon="plus"
            label=""
            pill
            size="small"
            type="secondary"
          />
        </LeftButtonContainer>
        <RightButtonContainer>
          <Button
            icon="arrowUp"
            label=""
            pill
            size="small"
            type="primary"
          />
        </RightButtonContainer>
      </ButtonsRow>
    </TextInputContainer>
  );
};

export default TextInput;

